import { convertToRole } from 'services/Users';
import { AuthType, AuthRawType } from './types';

export const convertResponseLogin = (data: AuthRawType): AuthType => ({
    username: data.username,
    email: data.email,
    role: convertToRole(data.roles)
});
